export const auth: {
  role: string | null;
  email: string | null;
  mfaPreference: string | null;
  mfaEnabled: boolean | null;
} = {
  role: null,
  email: null,
  mfaPreference: null,
  mfaEnabled: null,
};

export function setCognitoRole(role: string | null) {
  auth.role = role;
}

export function getCognitoRole() {
  return auth.role;
}

export function setEmail(email: string | null) {
  auth.email = email;
}

export function setMFAPreference(mfaPreference: string | null) {
  auth.mfaPreference = mfaPreference;
}

export function getEmail() {
  return auth.email;
}

export function getMFAPreference() {
  return auth.mfaPreference;
}

export function getMFAEnabled() {
  return auth.mfaEnabled;
}

export function setMFAEnabled(enabled: boolean | null) {
  auth.mfaEnabled = enabled;
}

export const clearSession = () => {
  setCognitoRole(null);
  setEmail(null);
  setMFAPreference(null);
  setMFAEnabled(null);
  sessionStorage.clear();
};

export const setSession = ({
  email,
  role,
  mfaPreference,
  mfaEnabled,
}: {
  email: string;
  role: string;
  mfaPreference: string;
  mfaEnabled: boolean;
}) => {
  setEmail(email);
  setCognitoRole(role);
  setMFAPreference(mfaPreference);
  setMFAEnabled(mfaEnabled);
};
